import { Declaration } from 'store/declarations/declaration';
import { DeclarationStatuses } from 'store/declarations/enums/common/declaration-status';
import { declarationHasBeenSubmitted } from '../../../declarations/utils/form-utils';

const getDeclarationPath = (basePath: string, record: Declaration): string => {
    const separator = basePath.endsWith('/') ? '' : '/';
    let pathSuffix = '';

    if (declarationHasBeenSubmitted(record.status) || record.archived) {
        pathSuffix = '/view-only';
    } else if (
        record.status === DeclarationStatuses.RELEASED ||
        record.status === DeclarationStatuses.GOODS_RELEASED_FOR_EXPORT
    ) {
        pathSuffix = '/summary';
    }

    return `${basePath}${separator}${record.id}${pathSuffix}`;
};

export default getDeclarationPath;
